import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import g from "glamorous";
import { css } from "glamor";
import Img from "gatsby-image";
import { FaFacebookSquare } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";

const Div = g.div({
  borderRadius: `4px`,
  padding: `1.2em .75em .5em`,
  backgroundColor: `white`,
  border: `1px solid rgba(73,105,126,0.08)`,
  boxShadow: `0 1px 7px rgba(0,0,0,.05)`,
  marginBottom: `2em`,
});

const Nom = g.div({
  fontSize: `21px`,
  fontWeight: `600`,
  color: `#3c4d68`,
  marginTop: `1px`,
  marginBottom: `5px`,
  letterSpacing: `.015em`,
});

const P = g.p({
  fontSize: `14px`,
  lineHeight: `23px`,
});

const cssFa = css({
  color: `#3c4d68`,
  fontSize: `1.4em`,
  padding: `0 .6em`,
  marginBottom: `10px`,
});

export default () => (
  <StaticQuery
    query={graphql`
      query bio {
        file(
          relativePath: {
            eq: "images/dr-cedric-kron-chirurgien-esthetique-a-paris-04.jpg"
          }
        ) {
          childImageSharp {
            resize(width: 1500, height: 1500) {
              src
            }
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    `}
    render={(data) => (
      <Div>
        <div
          css={{
            width: `145px`,
            float: `left`,
            padding: `.2em`,
            borderRadius: `4px`,
            marginRight: `12px`,
          }}
        >
          {" "}
          <Link to="/chirurgien-esthetique-paris/">
            <Img
              fluid={data.file.childImageSharp.fluid}
              alt="Dr Cédric Kron, chirurgien esthétique à Paris"
            />
          </Link>
        </div>
        <Link to="/chirurgien-esthetique-paris/">
          <Nom>Dr Cédric Kron - Chirurgien esthétique à Paris</Nom>
        </Link>

        <P>
          Membre de l’Académie Nationale de Chirurgie, Ancien Interne Médaille
          d'Or de Chirurgie et Chef de clinique des Hôpitaux de Paris, le Dr
          Kron est qualifié en Chirurgie Plastique, Reconstructrice et
          esthétique. Il exerce son activité de chirurgien esthétique à Paris,
          dans un centre dédié à une prise en charge sur-mesure du visage et du
          corps.
        </P>

        <div css={{ textAlign: `right`, paddingRight: `.5em` }}>
          <a
            href="https://www.facebook.com/DrCedricKron"
            title="Page Facebook du Dr
      Cédric Kron à Paris"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookSquare {...cssFa} />
          </a>
          <a
            href="https://www.instagram.com/docteurkron/"
            title="Compte instagram du cabinet du Dr Cédric Kron"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram {...cssFa} />
          </a>
          <a
            href="https://twitter.com/Dr_Kron"
            title="Compte Twitter du Dr Cédric Kron, chirurgien esthétique"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter {...cssFa} />
          </a>
          <a
            href="https://www.youtube.com/channel/UCCbRUwoTEbXraAeMVIN9DuA"
            title="Chaine Youtube du Dr Cédric Kron"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube {...cssFa} />
          </a>
          <a
            href="https://www.linkedin.com/in/kron-c%C3%A9dric-28492917/"
            title="Profil Linkedin du Dr Cédric Kron"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin {...cssFa} />
          </a>
        </div>
      </Div>
    )}
  />
);
